import { api } from '../../AxiosConfig';

export class DashboardService {
    getInfoHeader(competence: string, atendenteId?: string) {
        return api.get(`dashboard/getInfoHeader/${competence}/${atendenteId}`);
    }

    getConclusoesCompetence(competence: string, atendenteId?: string) {
        return api.get(`dashboard/getConclusoesCompetence/${competence}/${atendenteId}`);
    }

    getFaturamentoMes(competence: string, atendenteId?: string) {
        return api.get(`dashboard/getFaturamentoMes/${competence}/${atendenteId}`);
    }

    getStatusAtual(currentDate: string, atendenteId?: string) {
        return api.get(`dashboard/getStatusAtual/${currentDate}/${atendenteId || ''}`);
    }

    getVisaoGeral(currentDate: string, atendenteId?: string) {
        return api.get(`dashboard/getVisaoGeral/${currentDate}/${atendenteId}`);
    }

    getExecutivo(params: { startAt: string; endAt: string; attendantId?: string }) {
        return api.get('dashboard/executivo', { params });
    }

    getClientes(params: { startAt: string; endAt: string; attendantId?: string }) {
        return api.get('dashboard/clientes', { params });
    }

    getTime(params: { startAt: string; endAt: string; attendantId?: string }) {
        return api.get('dashboard/time', { params });
    }

    getEstoque(params: { startAt: string; endAt: string }) {
        return api.get('dashboard/estoque', { params });
    }

    getVendas(params: { startAt: string; endAt: string }) {
        return api.get('dashboard/vendas', { params });
    }
}
